
import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TranslatePipe } from '@ngx-translate/core';
// import { SearchInputComponent } from '../search-input/search-input.component';

@Component({
    selector: 'app-timezone-dialog',
        standalone: true,
imports: [
    FormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
    MatButtonModule,
    MatInputModule,
    TranslatePipe
],
    templateUrl: './timezone-dialog.component.html',
    styleUrl: './timezone-dialog.component.scss'
})
export class TimezoneDialogComponent {
  timezones: string[] = [];
  filteredTimezones: string[] = [];
  selectedTimezone: string = '';
  searchQuery: string = '';
  constructor(
    public dialogRef: MatDialogRef<TimezoneDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { currentTimezone: string; translations: any }
  ) {
  }

  ngOnInit(): void {
    // Get all available timezones
    // This is a limited list - in a real app, you'd want a more complete list
    this.timezones = [
      'Africa/Cairo',
      'America/New_York',
      'America/Chicago',
      'America/Denver',
      'America/Los_Angeles',
      'America/Phoenix',
      'America/Anchorage',
      // 'America/Honolulu',
      'America/Toronto',
      'America/Vancouver',
      'America/Mexico_City',
      'Europe/London',
      'Europe/Paris',
      'Europe/Berlin',
      'Europe/Rome',
      'Europe/Madrid',
      'Europe/Moscow',
      'Asia/Tokyo',
      'Asia/Shanghai',
      'Asia/Singapore',
      'Asia/Dubai',
      'Asia/Hong_Kong',
      'Asia/Seoul',
      'Australia/Sydney',
      'Australia/Melbourne',
      'Pacific/Auckland',
      'UTC',
    ];

    // Sort alphabetically
    this.timezones.sort();

    // Initialize filtered list
    this.filteredTimezones = [...this.timezones];

    // Set initial selection if available
    if (this.data && this.data.currentTimezone) {
      this.selectedTimezone = this.data.currentTimezone;
    }
  }

  filterTimezones(): void {
    if (!this.searchQuery) {
      this.filteredTimezones = [...this.timezones];
      return;
    }

    const query = this.searchQuery.toLowerCase();
    this.filteredTimezones = this.timezones.filter((tz) =>
      tz.toLowerCase().includes(query)
    );
  }

  selectTimezone(timezone: string): void {
    this.selectedTimezone = timezone;
  }

  getTimeInZone(timezone: string): string {
    try {
      return new Date().toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        timeZone: timezone,
      });
    } catch (error) {
      return '--:--:--';
    }
  }
  getTimezoneOffset(timezone: string): string {
    try {
      // Create a stable date (UTC midnight)
      const date = new Date(Date.UTC(2000, 0, 1, 0, 0, 0));

      // Get the ISO string with the specific timezone
      const timeStringInTZ = date.toLocaleString('en-GB', {
        timeZone: timezone,
        timeZoneName: 'longOffset',
      });

      // Extract GMT offset using regex (looking for something like GMT+2 or GMT-05:00)
      const gmtMatch = timeStringInTZ.match(/GMT[+-]\d{1,2}(?::\d{2})?/);
      if (gmtMatch) {
        return gmtMatch[0];
      }

      // Alternative calculation using the Date object
      // Get UTC and TZ timestamp for comparison
      const utcTime = Date.UTC(2000, 0, 1, 0, 0, 0);

      // Convert to timezone date object
      const tzOptions = {
        timeZone: timezone,
        year: 'numeric' as 'numeric',
        month: 'numeric' as 'numeric',
        day: 'numeric' as 'numeric',
        hour: 'numeric' as 'numeric',
        minute: 'numeric' as 'numeric',
        second: 'numeric' as 'numeric',
        hour12: false,
      };
      const tzString = new Intl.DateTimeFormat('en-US', tzOptions).format(date);
      const tzDate = new Date(tzString);

      // Calculate the offset in minutes
      const offsetInMinutes = (tzDate.getTime() - utcTime) / 60000;

      // Format the offset as GMT±HH:MM
      const hours = Math.floor(Math.abs(offsetInMinutes) / 60);
      const minutes = Math.abs(Math.round(offsetInMinutes % 60));
      const sign = offsetInMinutes >= 0 ? '+' : '-';

      return `GMT${sign}${hours.toString().padStart(2, '0')}:${minutes
        .toString()
        .padStart(2, '0')}`;
    } catch (error) {
      console.error('Error calculating timezone offset:', error);
      return 'GMT';
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    this.dialogRef.close(this.selectedTimezone);
  }
}
